import MarketingCampaign from './MarketingCampaign.component';

export default { MarketingCampaign };
